import axios from 'axios'
import CreateAddress from './dto/CreateAddress'
import {EntityDto} from '../../../../../services/dto/entityDto'
import {PagedAddressResultRequestDto} from './dto/PagedAddressResultRequestDto'
import {PagedResultDto} from '../../../../../services/dto/pagedResultDto'
import GetAllAddresses from './dto/GetAllAddresses'
import UpdateAddress from './dto/UpdateAddress'
import GetAddress from './dto/GetAddress'

const API_URL = process.env.REACT_APP_SERVICE_API_URL
export const URL_CREATE = `${API_URL}/Address/Create`
export const URL_DELETE = `${API_URL}/Address/Delete`
export const URL_UPDATE = `${API_URL}/Address/Update`
export const URL_GET = `${API_URL}/Address/Get`
export const URL_GET_ALL = `${API_URL}/Address/GetPagedAll`
export const URL_GET_BY_USER_ID = `${API_URL}/Address/GetByUserId`
export const URL_GET_MY_ADDRESSES = `${API_URL}/Address/GetMyPagedAll`
export const URL_GET_ALL_USER = `${API_URL}/Address/GetListByUserSelf`
export const URL_CREATE_USER = `${API_URL}/Address/CreateForUser`
export const URL_DELETE_USER = `${API_URL}/Address/DeleteForUser`
export const URL_UPDATE_USER = `${API_URL}/Address/UpdateForUser`



export function onGetMyAddresses(): Promise<GetAddress> {
  return axios.get(URL_GET_MY_ADDRESSES)
}

export function onGetAddressesByUserId(user: EntityDto): Promise<GetAddress> {
  return axios.get(URL_GET_BY_USER_ID, {params: user})
}
export function onGetAddress(entityDto: EntityDto): Promise<GetAddress> {
  return axios.get(URL_GET, {params: entityDto})
}

export function onGetPagedAllAddresses(
  pagedFilterAndSortedRequest: PagedAddressResultRequestDto
): Promise<PagedResultDto<GetAllAddresses>> {
  return axios.get(URL_GET_ALL, {params: pagedFilterAndSortedRequest})
}

export function onGetPagedAllUserAddresses(): Promise<PagedResultDto<GetAllAddresses>> {
  return axios.get(URL_GET_ALL_USER)
}

export function onCreateAddress(createAddress: CreateAddress): Promise<boolean> {
  return axios.post(URL_CREATE, createAddress)
}
export function onDeleteAddress(entityDto: EntityDto): Promise<boolean> {
  return axios.delete(URL_DELETE, {params: entityDto})
}
export function onUpdateAddress(updateAddressInput: UpdateAddress): Promise<boolean> {
  return axios.put(URL_UPDATE, updateAddressInput)
}

export function onCreateUserAddressforUser(createAddress: CreateAddress): Promise<boolean> {
  return axios.post(URL_CREATE_USER, createAddress)
}
export function onDeleteUserAddressforUser(entityDto: EntityDto): Promise<boolean> {
  return axios.delete(URL_DELETE_USER, {params: entityDto})
}
export function onUpdateUserAddressforUser(updateAddressInput: UpdateAddress): Promise<boolean> {
  return axios.put(URL_UPDATE_USER, updateAddressInput)
}
